/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, SearchModal, StyledDialog } from './modal-conditions.css';
import '@reach/dialog/styles.css';
import { IoIosAddCircleOutline } from 'react-icons/io';

// This component is here only to to showcase the
// React Context integration. No need to keep this if
// you don't require a Modal in your project.
export default class Modal extends PureComponent {
  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
    this.disableScrolling(false);
  }

  onKeyDown = ({ key }) => {
    if (key === 'Escape') {
      this.props.open && this.props.hideModal();
    }
  };

  disableScrolling(open) {
    // Disables scrolling when the modal is open, as suggested by
    // https://www.w3.org/TR/2017/NOTE-wai-aria-practices-1.1-20171214/examples/dialog-modal/dialog.html
    if (open) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
    }
  }

  render() {
    const { children, buttonText, handleModal, open } = this.props;

    if (typeof document !== 'undefined') {
      this.disableScrolling(open);
    }

    return (
      <div>
        <Button type="button" onClick={handleModal} className={'modal-btn'}>
          <div className={'text-box'}>{buttonText}</div>
          <IoIosAddCircleOutline />
        </Button>
        <StyledDialog isOpen={open}>
          <SearchModal>
            <div>{children}</div>
          </SearchModal>
        </StyledDialog>
      </div>
    );
  }
}

Modal.propTypes = {
  handleModal: PropTypes.any,
  children: PropTypes.node,
  open: PropTypes.bool.isRequired,
  showModal: PropTypes.func,
  hideModal: PropTypes.func,
  buttonText: PropTypes.string,
  close: PropTypes.any,
};
